import { render, staticRenderFns } from "./message-revoked.vue?vue&type=template&id=cd3867c8&scoped=true"
import script from "./message-revoked.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-revoked.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-revoked.vue?vue&type=style&index=0&id=cd3867c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3867c8",
  null
  
)

export default component.exports